import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=8b839224"
import script from "./FormCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=8b839224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports